<script>
    import { flip } from 'svelte/animate';
    import { crossfade } from 'svelte/transition';
    import { tcc_json } from '$lib/static/tcc_json.js';
    import { tooltip } from '$lib/app/tooltip.js';

    let { user_tcc } = $props();

    const [send, receive] = crossfade({});

    const tcc_to_continents = {
        "AFR": "Africa",
        "ANT": "Antarctica",
        "ASI": "Asia", "MID": "Asia",
        "CAM": "North America", "CRB": "North America", "NAM": "North America",
        "EUR": "Europe",
        "PAC": "Australia and Oceania",
        "SAM": "South America"
    };

    const continents_i = {
        "Europe": "europe.png",
        "North America": "north-america.png",
        "Asia": "asia.png",
        "Africa": "africa.png",
        "South America": "south-america.png",
        "Australia and Oceania": "australia.png",
        "Antarctica": "antarctica.png"
    }

    let continents = $derived.by(() => {
        let continents = {};
        if(user_tcc) {
            for (const reg of tcc_json) {
                if(!continents[tcc_to_continents[reg.reg]]) {
                    continents[tcc_to_continents[reg.reg]] = reg.db.some((x) => user_tcc[x.id] > 0);
                }
            }
        }
        return continents;
    });
</script>
<span>
    <span>
        {#each Object.keys(continents_i).filter(i => continents[i]) as j (j)}
            <span   use:tooltip
                    data-tooltip='{j} ✓'
                    animate:flip
                    in:receive={{key: j}} 
                    out:send={{key: j}}><img src={'/i/c/'+continents_i[j]} alt='{j} ✓' width=32 height=32/></span>
        {/each}
    </span>
    <span>
        {#each Object.keys(continents_i).filter(i => !continents[i]) as j (j)}
            <span   use:tooltip
                    data-tooltip='{j} ❌' 
                    animate:flip 
                    in:receive={{key: j}} 
                    out:send={{key: j}}><img src={'/i/bw/'+continents_i[j]} alt='{j} ×' width=32 height=32/></span>
        {/each}
    </span>
</span>

